import { Dispatch } from "redux";
import { LoginService } from "../../services/LoginService";
import { donorapi } from "../../ApiNames";

export const fetchDataSuccess=(data:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchreportdatas=(data:any) =>({
    type: 'FETCH_REPORT_DATA_SUCCESS',
    payload: data,
});


export const fetchdata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid, q :1 };
            const apiname = donorapi.fundmanager;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const fetchreportdata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid};
            const apiname = donorapi.fundreports;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchreportdatas(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

